const axios = require("axios");
const { default: Property } = require("../model/property");
const ACCESS_TOKEN =
  process.env.ACCESS_TOKEN || process.env.REACT_APP_ACCESS_TOKEN;
/* NodeJS */
const url = process.env.REACT_APP_BASE_URL;
const coreUrl = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;
/* Core */
// const url_core = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL
/* Proxy */
// const url = process.env.REACT_APP_BASE_PROXY_URL

module.exports = {
  getPrices: (storeUid, type, products, options = [], k) =>
    axios({
      method: "POST",
      url: `${url}/fulfillments/price_detail`,
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
      data: {
        uid: storeUid,
        type: type,
        products: products,
        pick_options: options,
        k: k,
      },
    }),
  postOrders: (
    storeUid,
    type,
    products,
    expireKey,
    notes,
    notesSelectionOptions,
    lastName,
    roomNumber,
    language,
    accessToken,
    platform,
    deviceType,
    paymentId,
    paymentSelected,
    autoReminder = null,
    options = []
  ) =>
    axios({
      method: "POST",
      url: `${coreUrl}/fulfillments/create_orders`,
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
      data: {
        uid: storeUid,
        k: expireKey,
        type: type,
        products: products,
        notes: notes,
        notes_selection_options: notesSelectionOptions,
        last_name: lastName,
        room_number: roomNumber,
        language: language,
        access_token: accessToken,
        platform: platform,
        deviceType: deviceType,
        payment_id: paymentId,
        pick_options: options,
        auto_reminder_base_time: autoReminder,
        payment_method_type: paymentSelected,
      },
    }),
  postFulfillment: (
    accessToken,
    fulfillmentTypeName,
    deviceType,
    body,
    autoReplyMessage,
    requestTitle,
    node,
    platform,
    lastName,
    roomNumber,
    token,
    autoReminder = null
  ) =>
    axios({
      method: "POST",
      url: `${coreUrl}/fulfillments/create_fulfillment_node`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        fulfillment: {
          fulfillment_type_name: fulfillmentTypeName,
          device_type: deviceType,
        },
        body: body,
        auto_reply_message: autoReplyMessage,
        platform: platform,
        request_title: requestTitle,
        node: node,
        room_number: roomNumber,
        last_name: lastName,
        auto_reminder_base_time: autoReminder,
        user_token: token,
      },
    }),
  postUploadPhoto: (accessToken, photo, fulfillmentId, title = "Okkami") => {
    let data = new FormData();
    data.append("id", fulfillmentId);
    data.append("photo", photo);
    data.append("title", title);
    return axios({
      method: "POST",
      url: `${coreUrl}/fulfillments/upload_photo`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });
  },
  createAdyenSession: (
    storeUid,
    type,
    products,
    k,
    options = [],
    returnUrl,
    lastName,
    roomNumber,
    accessToken,
    notes
  ) => {
    return axios({
      method: "POST",
      url: `${url}/fulfillments/adyen_session`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        uid: storeUid,
        type: type,
        products: products,
        return_url: returnUrl,
        k: k,
        pick_options: options,
        room_number: roomNumber,
        access_token: accessToken,
        last_name: lastName,
        email: Property.getInputEmail(),
        notes: notes,
      },
    });
  },
  createAdyenPreAuthSession: (
    nodeId,
    propertyUid,
    returnUrl,
    amount,
    currency,
    language,
    booking,
    accessToken
  ) => {
    return axios({
      method: "POST",
      url: `${coreUrl}/payment_transactions`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        amount,
        booking,
        language,
        node_id: nodeId,
        currency_code: currency,
        access_token: accessToken,
        uid: propertyUid,
        type: "Property",
        payment_action: "pre_auth",
        return_url: returnUrl,
      },
    });
  },

  createAdyenPreAuthPayment: (
    propertyUid,
    reference,
    amount,
    currency,
    language,
    bookingNumber,
    resvId,
    adyenPayload,
    accessToken,
    returnUrl = null
  ) => {
    const data = {
      amount,
      currency,
      reference,
      language,
      adyen_payload: adyenPayload,
      resv_id: resvId,
      booking_number: bookingNumber,
      currency_code: currency,
      access_token: accessToken,
      uid: propertyUid,
      platform: "web",
      type: "Property",
      payment_action: "pre_auth",
      return_url: returnUrl,
    };
    return axios({
      method: "POST",
      url: `${coreUrl}/payment_transactions/adyen_payments`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data,
    });
  },

  getAdyenPreAuthPaymentStatus: (
    propertyUid,
    reference,
    jobId,
    dataType,
    accessToken
  ) => {
    const params = {
      reference,
      job_id: jobId,
      data_type: dataType,
      access_token: accessToken,
      uid: propertyUid,
      platform: "web",
      type: "Property",
      payment_action: "pre_auth",
    };
    return axios({
      method: "GET",
      url: `${coreUrl}/payment_transactions/adyen_payments_status`,
      headers: { Authorization: `Bearer ${accessToken}` },
      params,
    });
  },
};
